import { getDelayAction } from 'automaton/actions/DelayAction'
import { getReelSpinAction } from 'automaton/actions/ReelSpinAction'
import { getRequestRespinAction } from 'automaton/actions/RequestRespinAction'
import { getAutoState } from 'automaton/states/AutoSpinState'
import { getAutoWinState } from 'automaton/states/AutoWinState'
import { getBetState } from 'automaton/states/BetState'
import { getFreespinAddState } from 'automaton/states/FreespinsAddState'
import { AutoSpinManager } from 'managers/AutoSpinManager'

export function getAutoRespinState() {
  const winModel = game.models.WinModel.get()
  const freespinModel = game.models.FreespinModel.get()
  const spinModel = game.models.SpinModel.get()

  const name = 'RESPIN'
  const actions = [
    getRequestRespinAction(),
    game.models.GameModel.requestAgainAllowed
      ? getDelayAction(0.1)
      : getReelSpinAction(),
  ]
  const transition = () =>
    game.models.GameModel.requestAgainAllowed
      ? getBetState()
      : winModel.winLines.length
        ? getAutoWinState()
        : spinModel.respin.length
          ? AutoSpinManager.isAllowed()
            ? getAutoState()
            : getAutoRespinState()
          : freespinModel.add
            ? getFreespinAddState(false)
            : AutoSpinManager.isAllowed()
              ? getAutoState()
              : getBetState()

  return {
    name,
    actions,
    transition,
  }
}
